import { RobotApi } from 'api/RobotApi'
import { ApiError, MissionJobTypeEnum, SchedulerSettings } from 'api/schema'
import { RobotActions } from 'store/actions/robot'
import { MISSION_JOB_STATUSES, PROGRESS_TYPES, ROBOT_MODES } from 'utils/constants'
import { RootState } from 'utils/interfaces'

const createJob = (missionId: number, robotId: number) => {
  // Пока не используется, мб удалить?
  return async (dispatch: any, getState: () => RootState) => {
    try {
      dispatch(RobotActions.setCreatingJobProgress(PROGRESS_TYPES.WORK))
      const job = await RobotApi.createJob(missionId, robotId)
      dispatch(RobotActions.setJobId(job.id))
      dispatch(RobotActions.setCreatingJobProgress(PROGRESS_TYPES.SUCCESS))
    } catch (error) {
      dispatch(RobotActions.setCreatingJobProgress(PROGRESS_TYPES.ERROR))
      console.log('Error creating job')
    }
  }
}

const uploadJobToRobot = (jobId: number) => {
  // Пока не используется, мб удалить?
  return async (dispatch: any, getState: () => RootState) => {
    try {
      dispatch(RobotActions.setUploadingJobProgress(PROGRESS_TYPES.WORK))
      await RobotApi.uploadJobToRobot(jobId)
      dispatch(RobotActions.setUploadingJobProgress(PROGRESS_TYPES.SUCCESS))
    } catch (error) {
      dispatch(RobotActions.setUploadingJobProgress(PROGRESS_TYPES.ERROR))
      console.log('Error creating job')
    }
  }
}

const updateJobAndUploadJobToRobot = (
  taskId: number,
  missionId: number,
  robotId: number,
  scheduler_settings?: SchedulerSettings,
  name?: string
) => {
  return async (dispatch: any, getState: () => RootState) => {
    try {
      dispatch(RobotActions.setUploadingJobProgress(PROGRESS_TYPES.WORK))
      const job = await RobotApi.updateTheEntireJob(taskId, missionId, robotId, scheduler_settings, name)
      dispatch(RobotActions.setJobId(job.id))
      dispatch(RobotActions.setJobStatus(MISSION_JOB_STATUSES.CALCULATING))
      await RobotApi.uploadJobToRobot(job.id)
      dispatch(RobotActions.setUploadingJobProgress(PROGRESS_TYPES.SUCCESS))
    } catch (error) {
      dispatch(RobotActions.setUploadingJobProgress(PROGRESS_TYPES.ERROR))
      console.log('Error updating job')
    }
  }
}

const updateJobTypeAndUploadJobToRobot = (taskId: number, job_type: MissionJobTypeEnum) => {
  return async (dispatch: any, getState: () => RootState) => {
    try {
      dispatch(RobotActions.setUploadingJobProgress(PROGRESS_TYPES.WORK))
      const job = await RobotApi.updateMissionJobType(taskId, job_type)
      dispatch(RobotActions.setJobId(job.id))
      dispatch(RobotActions.setJobStatus(MISSION_JOB_STATUSES.CALCULATING))
      await RobotApi.uploadJobToRobot(job.id)
      dispatch(RobotActions.setUploadingJobProgress(PROGRESS_TYPES.SUCCESS))
    } catch (error) {
      dispatch(RobotActions.setUploadingJobProgress(PROGRESS_TYPES.ERROR))
      console.log('Error updating job')
    }
  }
}

const setRobotMode = (robotId: number, mode: ROBOT_MODES, metadata?: import('api/RobotApi').MappingMetadata) => {
  return async (dispatch: any, getState: () => RootState) => {
    try {
      await RobotApi.switchMode(robotId, mode, metadata)
    } catch (error) {
      dispatch(RobotActions.setUploadingJobProgress(PROGRESS_TYPES.ERROR))
      console.log('Error setting robot mode', error)
    }
  }
}

const setRobotNotSetMode = (robotId: number) => {
  return async (dispatch: any, getState: () => RootState) => {
    try {
      await RobotApi.switchMode(robotId, ROBOT_MODES.MODE_NOT_SET)
    } catch (error) {
      dispatch(RobotActions.setUploadingJobProgress(PROGRESS_TYPES.ERROR))
      console.log('Error setting robot mode')
    }
  }
}

const fetchRobot = (robotId: number) => {
  return async (dispatch: any, getState: () => RootState) => {
    try {
      dispatch(RobotActions.setLoadingProgress(PROGRESS_TYPES.WORK))
      const robotInfo = await RobotApi.fetchRobot(robotId)
      dispatch(RobotActions.setRobotInfo(robotInfo))
      dispatch(RobotActions.setLoadingProgress(PROGRESS_TYPES.SUCCESS))
    } catch (error) {
      // Silently handle network errors (ERR_NETWORK_CHANGED, Failed to fetch, etc.)
      // These are common when network connection is unstable and don't need user attention
      if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message.includes('network'))) {
        // Network error - silently ignore, will retry on next interval
        // Don't set ERROR state for network issues
        return
      }
      // For other errors, set error state
      dispatch(RobotActions.setLoadingProgress(PROGRESS_TYPES.ERROR))
      console.warn('[robotThunks] fetchRobot error:', error)
      if (error instanceof ApiError && error.status === 404) {
        throw error
      }
    }
  }
}

/** Fetch robot without changing loadingProgress (for polling on Mission Control so interval is not affected). */
const fetchRobotSilent = (robotId: number) => {
  return async (dispatch: any, getState: () => RootState) => {
    try {
      const robotInfo = await RobotApi.fetchRobot(robotId)
      dispatch(RobotActions.setRobotInfo(robotInfo))
    } catch (error) {
      if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message.includes('network'))) {
        return
      }
      console.warn('[robotThunks] fetchRobotSilent error:', error)
    }
  }
}

export const robotThunks = {
  createJob,
  uploadJobToRobot,
  updateJobAndUploadJobToRobot,
  updateJobTypeAndUploadJobToRobot,
  setRobotMode,
  fetchRobot,
  fetchRobotSilent,
  setRobotNotSetMode,
}
